import React from 'react';
import { TrainingModule } from './TrainingGear';

const TrainingGearPage = ({ currentUser, onBackToGears }) => {
  return <TrainingModule onBack={onBackToGears} currentUser={currentUser} />;
};

export default TrainingGearPage;
